import { useAppSelector } from "@src/ducks/ducksHook";
import { selectedAuthGuestRole } from "@src/ducks/slices/auth.slice";
import { tabletSize } from "@src/utils/screensize-helper";
import React from "react";
import { View } from "react-native";
import { DrawerContext } from "../drawer-provider";
import MobileHeader from "./mobile";
import useStyles from "./styles.css";
import WebHeader from "./web-view";
import Header from "@src/screens/affix-document/header";
import Banner from "@src/screens/dashboard/banner-sticky/banner";


const DrawerHeader = () => {
  const styles = useStyles();
  const isTabletSize = tabletSize();
  const isGuest = useAppSelector(selectedAuthGuestRole);
  const { activeTab } = React.useContext(DrawerContext);
                                
  if(activeTab === "Affix Document"){
    return <Header />;
  }

  if(isGuest){
    return isTabletSize ? <>
        <View style={[styles.drawer_guest_item_header, { height: 75, paddingHorizontal: 15, borderBottomWidth: 0 }]}>
          <MobileHeader />
        </View>
      </> :
      <>
        <View style={[styles.drawer_guest_item_header, {  borderBottomWidth: 0 }]}>
        </View>
      </>;
  }

  return (
    <>
      <View style={styles.drawer_item_header}>
        {isTabletSize && !isGuest ? <MobileHeader /> : <WebHeader />}
      </View>
      {(activeTab === "Document Cancelled " || activeTab === "Document Sent") && <Banner /> }
      {(activeTab !== "Dashboard") && <View style={styles.v_height} />}
    </>
  );
};

export default DrawerHeader;
